import React from 'react';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

/**
 * @returns component that is used inside breadcrumb of view_project_data_model page. It returns button that navigates to view_page_data_model page  
 */
const ViewDataModelPage = () => {
  const navigate = useNavigate(); // initialize navigation

  // Function that navigates to view_page_data_model
  const changeToViewPageDataModel = () => {
    navigate('/view_page_data_model');
  };

  return (
    <div
      data-tooltip="View page data model"
      data-tooltip-pos="bottom"
      className={clsx('fa', 'fa-database', 'fa-database2', 'teamSelector')}
      onClick={changeToViewPageDataModel}
      style={{ paddingRight: '0.5vw', paddingLeft: '0.5vw', paddingTop: '0.5vw' }}
      aria-hidden="true"
    />
  );
};

export default ViewDataModelPage;
